import styled from 'styled-components';

export const Button = styled.button`
  cursor: pointer;
  height: 30px;
  padding: 0 15px;
  border-radius: 40px;
  justify-content: center;
  align-items: center;
  line-height: 1;
  border: none;
  outline: none;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.5), inset 0 0px 30px 0 rgba(0, 0, 0, 0);
  transition: 0.3s all ease-out;

  font-size: ${(props) => (props.fontSize ? props.fontSize : '15px')};
  display: ${(props) => (props.invisible ? 'none' : 'flex')};
  opacity: ${(props) => (props.disabled ? '0.4' : '1')};
  color: ${(props) => props.theme.color};
  background-color: ${(props) => props.theme.bgColor ?? '#ccc'};
  img,
  i {
    margin-right: 5px;
  }
  &:hover {
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.5), inset 0 0px 30px 0 rgba(0, 0, 0, 0.3);
  }
  &:disabled {
    cursor: not-allowed;
    box-shadow: none;
  }
  &.loading {
    opacity: 1;
    position: relative;
  }
  &.loading:after {
    content: '';
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    bottom: 0px;
    /* z-index: 999; */
    border-radius: 4px;
    cursor: not-allowed;
    background: rgba(255, 255, 255, 0.75) url(/images/loader.svg) no-repeat 50%;
  }
`;

// default theme
Button.defaultProps = {
  theme: {
    color: '#000',
    bgColor: '#dbdbdb',
  },
};

export const SquareButton = styled(Button)`
  height: 80px;
  width: 500px;
  padding: 0;
  border-radius: 4px;
  font-size: 26px;
  img,
  i {
    margin-right: 25px;
  }
`;

export const GradientButton = styled(Button)`
  background: ${(props) => props.theme.bg};
  border: solid 1px ${(props) => props.theme.border};
`;

export const SimpleButton = styled(Button)`
  cursor: pointer;
  font-size: 15px;
  color: #3ea5ff;
  padding: 0.5em 0;
  border: 0;
  box-shadow: none;
  background: none;
  i {
    margin-right: 5px;
  }
  &:hover {
    color: #fff;
    background: none;
    box-shadow: none;
  }
`;

export const Reset = styled.div`
  position: relative;
  padding-left: 24px;
  height: 40px;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  font-size: 15px;
  color: #3ea5ff;
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
  &:before,
  &:after {
    content: ' ';
    position: absolute;
    left: 10px;
    top: 10px;
    height: 20px;
    width: 2px;
    background-color: #0085ef;
  }
`;
